/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, setToken } from '../../utils/util';
import FacebookLogin from 'react-facebook-login';

import OzFormComponent from './OzFormComponent';
import './RegisterForm.css';

import {
  register,
  registerFacebook,
  login,
  fetchUser,
} from '../../actions';


class RegisterForm extends OzFormComponent {

  static fields = [
    'email',
    'username',
    'password',
  ]

  submit(e) {
    if (!this.props.doRegister) {
      return super.submit(e);
    }

    let values = this.getValues();
    this.register(e, values);
  }

  register(e, values) {
    e.preventDefault();
    this.props.register(values)
      .then(resp => {
        if (!resp.error) {
          return this.props.login({
            username: values.username,
            password: values.password,
          });
        }
      })
      .then(resp => {
        if (!resp.error) {
          setToken(resp.token);
          this.props.fetchUser()
            .then(resp => {
              if (this.props.onSuccess) {
                return this.props.onSuccess(resp);
              }
            });
        }
      });
  }

  responseFacebook(values) {
    console.log('facebook', values);
    if (values.status == 'unknown') {
      return;
    }

    this.props.registerFacebook(values)
      .then(resp => {
        console.log('register facebook resp', resp);
        setToken(resp.token);
        this.props.fetchUser()
          .then(resp => {
            if (this.props.onSuccess) {
              return this.props.onSuccess();
            }
          });
      });
  }

  renderBody() {
    return (
      <div className="RegisterForm">
        {/*
        <FacebookLogin
          appId="991492751183189"
          autoLoad={true}
          fields="name,email,picture"
          callback={(r) => this.responseFacebook(r)} />
        <hr/>
        */}

        {this.renderFormGroup('Email', 'text', 'email')}
        {this.renderFormGroup('Username', 'text', 'username')}
        {this.renderFormGroup('Password', 'password', 'password')}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    registerFacebook,
    login,
    fetchUser,
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RegisterForm.js
 **/